<template>
  <div>
    <div class="row">
      <div class="p-x-lg">
        <div class="col-sm-12 col-md-4">
          <div class="input-group m-t-xs w-xxl">
            <span class="input-group-addon no-border no-bg">
              <i class="fa fa-search opacity"></i>
            </span>
            <div class="profile-search">
              <input
                class="form-control form-control-lg no-border no-bg search-input ng-untouched ng-pristine ng-valid"
                v-model="searchTerm"
                placeholder="search products"
                style="padding-left: 0"
                type="text"
                @keyup.enter="addSearchFilter"
              />
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-8 p-r-md">
          <div v-if="isCorporateProfile" class="pull-right fa-hover text-right m-t-xs m-l-sm">
            <a @click="goToAddProductPage()" class="btn btn-dark b-a b-dark btn-sm btn-transparent">
              <i class="fa fa-plus"></i> add product
            </a>
          </div>
          <div class="pull-right m-t-xs">
            <select2 v-model="selectedSort" :hideSearchBox="true">
              <option value="-updated_at">Last updated</option>
              <option value="name">A-Z</option>
              <option value="-name">Z-A</option>
              <option value="price">Price low to high</option>
              <option value="-price">Price high to low</option>
            </select2>
          </div>
          <div class="pull-right m-t-xs">
            <select2
              v-model="selectedCategory"
              :options="categories"
              :disabledValues="selectedCategories"
            >
              <option disabled value>Category</option>
            </select2>
          </div>
        </div>
      </div>
    </div>
    <div v-if="filters.length > 0" class="row">
      <div class="p-x-lg">
        <div class="col-sm-12">
          <vue-tags-input
            :value="''"
            :tags="filters"
            :allow-edit-tags="true"
            :add-only-from-autocomplete="true"
            :placeholder="''"
            @tags-changed="filtersChanged"
          />
          <div class="filter-clear-button">
            <img
              @click="clearFilters"
              src="~@assets/img/clear-icon.png"
              width="24px"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row container--stretch">
      <div class="col-md-12 p-x-lg">
        <div class="container-fluid p-y">
          <div class="row">
            <div v-if="items">
              <div
                class="col-lg-3 col-md-4 col-sm-6 col-xs-12 p-b-md"
                v-for="(item, i) in items"
                :key="i"
              >
                <router-link :to="'/' + item.id">
                  <div class="item bg-white text-center">
                    <!-- <div v-if="item.labels" class="specialBtn">special</div>
                      <div v-if="false" class="clearanceBtn">clearance</div> -->
                    <img
                      class="item__avatar block-center"
                      :src="item.primaryImage.variants['256']"
                    />
                    <div class="item__footer m-t text-left">
                      <div class="item__footer__title">{{ item.name }}</div>
                      <div class="item__footer__model text-muted">
                        {{ item.model }}
                      </div>
                      <span
                        class="item__footer__price--current m-t-sm h5 text-black _500 block"
                        >RM
                        {{
                          item.discount_price ? item.discount_price : item.price
                        }}
                      </span>
                      <span
                        v-if="item.discount_price"
                        class="item__footer__price--old"
                      >
                        <span class="text-l-t">RM {{ item.price }}</span>
                        <span
                          >({{
                            100 -
                            Math.round(
                              (item.discount_price * 100) / item.price
                            )
                          }}% off)</span
                        >
                      </span>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <div
              v-if="(!items || items.length == 0) && !loader"
              class="text-center text-muted"
              style="font-style: italic; text-transform: lowercase"
            >
              no items found
            </div>
            <div v-if="loader">
              <pre-loader></pre-loader>
            </div>
          </div>
          <div class="text-center row" v-if="pageCount >= page">
            <div class="text-center m-t">
              <button
                @click="fetchMoreProducts"
                class="btn btn-s-md btn-sm btn-default org_list_more"
              >
                <i class="i i-arrow-down4"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import select2 from '@src/components/select2'
import ApiService from '@src/services/ApiService'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  data() {
    return {
      mpService: new ApiService(window.marketplace.apiUrl, null, null),
      mpStoreId: window.marketplace.store_id,
      mpStatusPublished: 10,

      loader: false,
      page: 1,
      pageCount: null,
      items: [],

      filters: [],
      selectedSort: '-updated_at',

      categories: [],
      selectedCategory: null,
      selectedCategories: [],

      searchTerm: null,
    }
  },
  computed:{
    isCorporateProfile() {
      return window.user.profile_type == 2;
    },
  },
  watch: {
    filters() {
      this.fetchProducts()

      this.selectedCategories = []
      this.filters.forEach((item) => {
        switch (item.id) {
          case 'category':
            this.selectedCategories.push(parseInt(item.value))
            break
        }
      })
    },
    selectedSort() {
      this.fetchProducts()
    },
    selectedCategory() {
      if (
        this.categories.filter((e) => e.id == this.selectedCategory).length > 0
      )
        this.filters.push({
          id: 'category',
          value: this.selectedCategory,
          text: this.categories.find((item) => item.id == this.selectedCategory)
            .name,
        })
    },
  },
  components: {
    select2,
  },
  created() {
    this.fetchProducts()
    this.fetchCategories()
  },
  methods: {
    fetchCategories() {
      this.mpService
        .get(`/categories?fields=id,name`)
        .then((res) => (this.categories = res.categories))
    },
    fetchProducts() {
      this.page = 1
      this.items = []
      this.fetchMoreProducts()
    },
    fetchMoreProducts() {
      this.loader = true
      let queryParams = this.prepareQueryParams()
      this.mpService.get(`/products?${queryParams}`).then((res) => {
        if (this.page === 1) {
          this.items = res.products
          this.pageCount = res.meta.last_page
        } else {
          this.items = this.items.concat(res.products)
        }
        this.page++
        this.loader = false
        this.selectedCategory = null
      })
    },
    prepareQueryParams() {
      let queryParams = `page=${this.page}`
      queryParams += `&store_id=${this.mpStoreId}`
      queryParams += `&status=${this.mpStatusPublished}`
      queryParams += `&sort=${this.selectedSort}`

      let categories = []
      this.filters.forEach((item) => {
        switch (item.id) {
          case 'category':
            categories.push(item.value)
            break
          case 'search':
            queryParams += `&searchTerms__in[]=${item.value}`
            break
        }
      })
      if (categories.length > 0)
        queryParams += `&categories__in=${categories.join()}`

      return queryParams
    },

    addSearchFilter() {
      this.filters.push({
        id: 'search',
        value: this.searchTerm,
        text: this.searchTerm,
      })
      this.searchTerm = ''
    },
    filtersChanged(filters) {
      this.filters = filters
    },
    clearFilters() {
      this.filters = []
    },

    goToAddProductPage(){
      window.location.assign(`${window.user.community_url}/${window.user.community_domain}/mp/create`);
    },
  },
}
</script>

<style lang="scss" scoped>
.item {
  height: 300px;
  .item__avatar {
    width: 85%;
  }
  .item__footer {
    width: 80%;
    .item__footer__title {
      color: #000;
      font-size: 16px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .item__footer__model {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .item__footer__price--old {
      font-size: 12px;
      color: #6c757d;
      height: 18px;
    }
  }
}
@media (max-width: 991px) {
  .item {
    height: 350px !important;
  }
}
@media (max-width: 767px) {
  .item {
    height: 380px !important;
    .item__avatar {
      width: 256px;
    }
  }
}

.specialBtn {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  background: #ff0221;
  border-radius: 0;
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  color: #fff;
  width: 80px;
  height: 19px;
  text-transform: uppercase;
  z-index: 999;
  font-family: Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.clearanceBtn {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  background: #ff8002;
  border-radius: 0;
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  color: #fff;
  width: 80px;
  height: 19px;
  text-transform: uppercase;
  z-index: 999;
  font-family: Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
</style>

<style lang="scss">
.select2-results .select2-highlighted {
  color: white !important;
  background-color: #337ab7;
}
.select2-drop-active {
  width: 200px !important;
}
.vue-tags-input {
  max-width: 100% !important;
  float: left;
  margin-right: 50px;
}
.vue-tags-input .ti-input {
  border: none;
}
.ti-tag {
  color: white !important;
  border: 1px solid #cbd5dd;
  background-color: #757575 !important;
  font-size: 14px !important;
  flex-direction: row-reverse;
  .ti-actions {
    margin-left: 0px !important;
    margin-right: 2px;
    font-size: 1em !important;
    .ti-icon-close {
      font-weight: 900 !important;
    }
  }
}
.filter-clear-button {
  position: absolute;
  right: 20px;
  top: 22%;
}
</style>
